import { baseApi } from '../baseApi';

import { CardRequestResponse } from './CardRequestResponse';
import { ConfirmPaymentFailedRequest } from './ConfirmPaymentFailedRequest';
import { LastSuccessfulPaymentResponse } from './LastSuccessfulPaymentResponse';

const eftProblemsSlice = baseApi
  .enhanceEndpoints({
    addTagTypes: ['EftProblems'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCardRequest: builder.query<CardRequestResponse, number>({
        query: (cardRequestId: number) => ({
          url: `/eft-problems/card-request/${cardRequestId}`,
          method: 'GET',
        }),
        providesTags: ['EftProblems'],
        keepUnusedDataFor: 0,
      }),
      getLastSuccessfulPayment: builder.query<LastSuccessfulPaymentResponse, { pinEntryDeviceId: number; cardRequestId?: number }>({
        // cardRequestId limits the lookup to payments taken before the disputed one
        query: ({ pinEntryDeviceId, cardRequestId }) => ({
          url: `/eft-problems/last-successful-payment/${pinEntryDeviceId}`,
          method: 'GET',
          params: cardRequestId ? { cardRequestId } : undefined,
        }),
        providesTags: ['EftProblems'],
        keepUnusedDataFor: 0,
      }),
      confirmPaymentFailed: builder.mutation<void, { transactionId: number; request: ConfirmPaymentFailedRequest }>({
        query: ({ transactionId, request }) => ({
          url: `/eft-problems/confirm-payment/${transactionId}/failed`,
          method: 'POST',
          body: request,
        }),
        invalidatesTags: ['EftProblems'],
      }),
    }),
  });

export const {
  useGetCardRequestQuery,
  useLazyGetCardRequestQuery,
  useGetLastSuccessfulPaymentQuery,
  useLazyGetLastSuccessfulPaymentQuery,
  useConfirmPaymentFailedMutation,
} = eftProblemsSlice;
